import * as React from "react";
import {BlackColor, IBackOfficeTheme, WhiteColor} from "../theme";
import {IconLiveLogo} from '../../components/Icons'
import {LiveNonLoggedBG} from "./components/NonLoggedBG/LiveNonLoggedBG";
import {Phone} from "../components/Phone";

const primaryColor = '#1a2448';
const alternateTextColor = WhiteColor;
const labelColor = '#FFF';

export const defaultTheme: IBackOfficeTheme = {
  primaryColor: primaryColor,
  accentColor: '#9c1737',
  accent2Color: '#2a4f4b',
  backgroundColor: primaryColor,
  alternateTextColor: alternateTextColor,
  labelColor: labelColor,
  logo: {
    component: IconLiveLogo,
    style: {
      width: 'auto',
      height: 150
    }
  },

  nonLogged: {
    bgComponent: LiveNonLoggedBG,
    phoneComponent: React.createElement(Phone),
    phoneScreenUrl: <string>require('./assets/phone_app.jpg'),
  },

  navBar: {
    logo: IconLiveLogo,
    backgroundColor: BlackColor,
    activeBackgroundColor: primaryColor,
    backgroundImage: <string>require('./assets/logo_bg.png'),
    color: WhiteColor,
    iconColor: '#df991f'
  }
};



// WEBPACK FOOTER //
// ./src/themes/default/index.ts